<template>
  <div>
    <form class="form-horizontal">
      <fieldset>
        <legend>{{ $t('filter') }}</legend>
        <div class="row">
          <div class="col-md-6">
            <div class="row form-group">
              <label class="col-form-label col-md-5"></label>
              <div class="col-md-5">
                <a-radio-group
                  v-model="acStatusId"
                  size="small"
                  @change="$emit('acStatusChange')"
                >
                  <a-radio-button :value="1">
                    {{ $t('studentScoringEntry.current') }}
                  </a-radio-button>
                  <a-radio-button :value="2">
                    {{ $t('studentScoringEntry.history') }}
                  </a-radio-button>
                </a-radio-group>
              </div>
            </div>

            <div class="row form-group">
              <label class="required col-form-label col-md-5">
                {{ $t('studentScoringEntry.className') }}
              </label>
              <div class="col-md-5">
                <a-select
                  v-model="model.class_id"
                  style="width: 150%; height: 35px"
                  :show-search="true"
                  option-filter-prop="children"
                  :filter-option="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :options="classList"
                  @change="onClassChange"
                ></a-select>
              </div>
            </div>

            <div class="row form-group">
              <label class="required col-form-label col-md-5">
                {{ $t('studentScoringEntry.scoringCycle') }}
              </label>
              <div class="col-md-5">
                <a-select
                  style="width: 150%"
                  v-model="model.scoring_cycle_id"
                  @change="scoringCycleChange"
                >
                  <a-select-option
                    v-for="(s, index) in scoringCycle"
                    :key="index"
                    :value="s.scoring_cycle_id"
                  >
                    {{ s.scoring_cycle_name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>

            <div class="row form-group" v-if="model.scoring_cycle_id != 4">
              <label class="required col-form-label col-md-5">
                {{ $t('studentScoringEntry.scoringCycleValue') }}
              </label>
              <div class="col-md-5">
                <select
                  style="width: 150%"
                  v-model.number="model.cycle_value"
                  v-if="[1, 4, 5, 7].includes(model.scoring_cycle_id)"
                  class="form-control"
                >
                  <option :value="null" disabled selected style="display: none">
                    {{ $t('select') }}
                  </option>
                  <option
                    v-for="(s, index) in scoringCycleValues"
                    :key="index"
                    :value="s.scoring_cycle_value"
                  >
                    {{ s.scoring_cycle_description }}
                  </option>
                </select>
                <input
                  v-else-if="[0, 2, 3].includes(model.scoring_cycle_id)"
                  v-model.number="model.cycle_value"
                  type="number"
                  style="width: 150%"
                  class="form-control"
                  readonly
                />
                <input
                  v-else
                  type="number"
                  class="form-control"
                  style="width: 150%"
                  readonly
                />
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row form-group">
              <label class="required col-form-label col-md-5">
                {{ $t('studentScoringEntry.mainProgram') }}
              </label>
              <div class="col-md-5">
                <input
                  v-show="acStatusId == 1"
                  type="text"
                  class="form-control"
                  readonly
                  :value="model.main_program"
                />
                <a-select
                  v-show="acStatusId == 2"
                  style="width: 100%"
                  v-model="model.acp_id"
                  :disabled="!!model.class_id"
                >
                  <a-select-option
                    v-for="(main, index) in mainProgramList"
                    :key="index"
                    :value="main.acp_id"
                  >
                    {{ main.acp_name_foreign }}
                  </a-select-option>
                </a-select>
              </div>
            </div>

            <div class="row form-group">
              <label class="required col-form-label col-md-5">
                {{ $t('studentScoringEntry.academicYear') }}
              </label>
              <div class="col-md-5">
                <a-select
                  style="width: 100%"
                  v-model="model.ac_year"
                  :disabled="acStatusId == 1 || !!model.class_id"
                >
                  <a-select-option
                    v-for="(year, index) in acYearList"
                    :key="index"
                    :value="year.ac_year"
                  >
                    {{ year.ac_year }}
                  </a-select-option>
                </a-select>
              </div>
            </div>

            <div class="row form-group">
              <label class="required col-form-label col-md-5">
                {{ $t('studentScoringEntry.academicTerm') }}
              </label>
              <div class="col-md-5">
                <input
                  v-show="acStatusId == 1"
                  type="text"
                  class="form-control"
                  readonly
                  :value="model.academic_term"
                />
                <a-select
                  v-show="acStatusId == 2"
                  style="width: 100%"
                  v-model="model.ac_term_id"
                  :disabled="!!model.class_id"
                >
                  <a-select-option
                    v-for="(term, index) in acTerms"
                    :key="index"
                    :value="term.ac_term_id"
                  >
                    {{ term.term_name + (term.ac_status_id == 1 ? ' ( Current ) ' : term.ac_status_id == 2 ? ' ( History ) ' : '( Next )') }}
                  </a-select-option>
                </a-select>
              </div>
            </div>

            <div class="row form-group">
              <label class="col-form-label col-md-5">
                {{ $t('studentScoringEntry.submissionDate') }}
              </label>
              <div class="col-md-5">
                <a-date-picker
                  v-model="model.submission_date"
                  style="width: 100%"
                  placeholder="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  format="DD-MM-YYYY"
                  @change="onChangeSubmissionDate"
                />
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'

export default {
  name: 'filterComponentScoreEntry',
  props: ['value', 'classOperations', 'validate'],
  data() {
    return {
      model: {},
      term_order: null
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    acYearList() {
      const years = this.classOperations.map(el => ({
        ac_year_id: el.ac_year_id,
        ac_year: el.academic_year ? el.academic_year.ac_year : ''
      }))
      return _.uniqBy(years, 'ac_year_id')
    },

    mainProgramList() {
      const programs = this.classOperations.map(el => ({
        acp_id: el.acp_id,
        acp_name_foreign: el.main_program ? el.main_program.acp_name_foreign : ''
      }))
      return _.uniqBy(programs, 'acp_id')
    },

    acTerms() {
      if (!this.model.ac_year_id || !this.model.acp_id) return []
      const terms = this.classOperations
        .filter(el => el.ac_year_id == this.model.ac_year_id && el.acp_id == this.model.acp_id)
        .map(el => ({
          ac_term_id: el.ac_term_id,
          term_name: el.academic_term ? el.academic_term.term_name : '',
          ac_status_id: el.academic_term ? el.academic_term.ac_status_id : null
        }))
      return _.uniqBy(terms, 'ac_term_id')
    },

    scoringCycle() { return this.$store.state.studentScoringEntry.scoring_cycles },
    
    scoringCycleValues() {
      if (!this.model.scoring_cycle_id) return this.$store.state.studentScoringEntry.scoring_cycle_values
      const allValues = this.$store.state.studentScoringEntry.scoring_cycle_values.filter(
        s => s.scoring_cycle_id == this.model.scoring_cycle_id
      )
      if (this.model.scoring_cycle_id == 7) {
        return this.term_order == 1 
          ? allValues.filter(s => [1, 2].includes(s.scoring_cycle_value))
          : allValues.filter(s => [3, 4, 5].includes(s.scoring_cycle_value))
      }
      return allValues
    },

    acStatusId: {
      get() { return this.$store.state.studentScoringEntry.ac_status_id },
      set(newValue) { this.$store.commit('studentScoringEntry/SET_AC_STATUS', newValue) }
    },

    classList() {
      const fullList = this.classOperations.map(el => {
        const teacherName = el.teacher ? el.teacher.full_name_en : ''
        const acYear = el.academic_year ? el.academic_year.ac_year : ''
        const programName = el.main_program ? el.main_program.acp_name_foreign : ''
        const termName = el.academic_term ? el.academic_term.term_name : ''
        const termOrder = el.academic_term ? el.academic_term.term_order : null

        return {
          value: el.class_id,
          label: el.class_name + '|' + teacherName + '|' + el.class_desc + '|' + acYear,
          ac_year_id: el.ac_year_id,
          ac_term_id: el.ac_term_id,
          term_order: termOrder,
          acp_id: el.acp_id,
          acps_id: el.acps_id,
          ac_year: acYear,
          main_program: programName,
          academic_term: termName
        }
      })

      if (this.acStatusId == 1) {
        return this.model.ac_year_id 
          ? fullList.filter(el => el.ac_year_id == this.model.ac_year_id)
          : fullList
      }
      return fullList
    }
  },
  methods: {
    ...mapActions('studentScoringEntry', ['getScoringCycle']),

    onClassChange(value, option) {
      const data = option.data.props
      
      this.model.acp_id = data.acp_id
      this.model.acps_id = data.acps_id
      this.model.ac_year_id = data.ac_year_id
      this.model.ac_term_id = data.ac_term_id
      
      this.model.ac_year = data.ac_year
      this.model.main_program = data.main_program
      this.model.academic_term = data.academic_term
      
      this.model.scoring_cycle_id = null
      this.model.cycle_value = null
      this.term_order = data.term_order
      
      this.getScoringCycle({ acps_id: data.acps_id })
    },

    scoringCycleChange() {
      const id = this.model.scoring_cycle_id
      if ([0, 2, 3].includes(id)) {
        this.model.cycle_value = this.term_order
      } else if (id == 4) {
        this.model.cycle_value = 1
      } else {
        this.model.cycle_value = null
      }
    },

    onChangeSubmissionDate(dateString) {
      this.model.submission_date = dateString
    }
  }
}
</script>